import { render, staticRenderFns } from "./add-oper-info.vue?vue&type=template&id=196d97d8"
import script from "./add-oper-info.vue?vue&type=script&lang=ts"
export * from "./add-oper-info.vue?vue&type=script&lang=ts"
import style0 from "./add-oper-info.vue?vue&type=style&index=0&id=196d97d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports